import { useEffect, useState, FunctionComponent, Dispatch, SetStateAction } from 'react'
import AccordionHeaderContainer from 'redux/containers/components/accordion/AccordionHeaderContainer'
import AccordionContainer from 'components/accordion/AccordionContainer'
import { GroupListItemContainerProps } from 'redux/containers/components/accordion/GroupListItemContainer'

const GroupListItem: FunctionComponent<GroupListItemProps> = ({
  props,
  state,
  expanded,
  isLoading,
  className,
  setAccordionExpandedNodeId,
  setAccordionExpandedNodeTitle,
  setAccordionBreadCrumbClicked
}) => {
  const [allContentExpanded, setAllContentExpanded] = useState(false)

  useEffect(() => {
    const { depth, id, title } = props
    if (depth === 1) {
      if (expanded) {
        setAccordionExpandedNodeId(id)
        setAccordionExpandedNodeTitle(title)
        setAccordionBreadCrumbClicked(false)
      }
    }
  })

  const { eventCategory, groupSource: { value } } = props
  const hideHeader = eventCategory === 'Legislation' && value && value.length === 1 && !value[0].title

  return (
    <li
      style={{ marginBottom: 0 }}
      className={className}
      id={props.id}
    >
      {!hideHeader && (
        <AccordionHeaderContainer
          {...props}
          {...state}
          {...{
            allContentExpanded,
            setAllContentExpanded,
            atBottom: 0,
            expanded: expanded && !isLoading
          }}
        />
      )}
      {expanded && !isLoading && (
        <Children
          props={props}
          state={state}
          {...{ allContentExpanded, setAllContentExpanded }}
        />
      )}
    </li>
  )
}

const Children: FunctionComponent<ChildrenProps> = ({ props, state, allContentExpanded = false, setAllContentExpanded }) => {
  const { depth, enableHighlight, highlight, eventCategory, cxNames, title } = props
  const { group } = state

  return (
    <AccordionContainer
      {...{
        parentTitle: eventCategory === 'Legislation' && title,
        depth: depth + 1,
        group,
        highlight: (enableHighlight && highlight) || null,
        eventCategory,
        allContentExpanded,
        setAllContentExpanded,
        cxNames
      }}
    />
  )
}

interface ChildrenProps {
  state: any;
  props: any;
  allContentExpanded: boolean;
  setAllContentExpanded: Dispatch<SetStateAction<boolean>>;
}

interface GroupListItemProps extends GroupListItemContainerProps{
  state: any;
  props: any;
  expanded: boolean;
  isLoading: boolean;
  className: string;
}

export default GroupListItem
